var React = require('react');

function Clear (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#323232;}")),React.createElement("path",{"className":"a","d":"M8.22,0a8.22,8.22,0,1,0,8.22,8.22A8.229,8.229,0,0,0,8.22,0Zm4.11,9.247H4.11V7.193h8.22Z","key":1})]);
}

Clear.defaultProps = {"width":"16.44","height":"16.44","viewBox":"0 0 16.44 16.44"};

module.exports = Clear;

Clear.default = Clear;
